import { buildStyledComponent, px2rem } from 'decisiv-ui-utils';

import Li from 'elements/Li';

const styles = `
  padding: 0 ${px2rem(25)};
`;

export default buildStyledComponent('ScrollableContainer.ListItem', Li, styles);



// WEBPACK FOOTER //
// ./src/blocks/ScrollableContainer/ListItem.js